module.exports = __webpack_public_path__ + "img/5_no.365ac959.svg";